export default function ($http) {
    return function (vrm) {
        return $http.get(`api/enquiriesforvrm/${vrm}`)
                .then(result => result.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/enquiries/getEnquiries.js